import { Column } from "../objects/column";
import { Language } from "../objects/language";
import { LanguageErrors } from "../objects/languageErrors";
import { LanguageListCriteria } from "../objects/languageListCriteria";


export const EMPTY_LANGUAGE: Language = {
    LocalTranslation: [],
    full_name: "",
    id: 0,
    language_code: ""
};


export const EMPTY_LANGUAGE_LIST_CRITERIA: LanguageListCriteria = {
    limit: 100,
    page: 0,
    order_by: '',
    order: 'asc',
    search: ''
};

export const EMPTY_LANGUAGE_ERRORS: LanguageErrors = {
    language_code_error: "",
    full_name_error: ""
};

export const LANGUAGE_INFO_ROUTE = '/language/edit/:id/info';
export const LANGUAGE_CONTACT_ROUTE = '/language/edit/:id/contact';

export const DEFAULT_COLUMN: Column[] = [
    {
        label: 'language-code',
        field_name: 'LANGUAGE_CODE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'full_name',
        field_name: 'FULL_NAME',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'fr',
        field_name: 'FR',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'en',
        field_name: 'EN',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    },
];


export const LANGUAGE_MODULE = 'LANGUAGE';
